import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetTeam =
  ({ callback, page, rowsPerPage, search }) =>
  async (dispatch, getState) => {
    try {
      const query = search
        ? `?search=${search}&limit=${1000}&page=${0}`
        : `?page=${page}&limit=${rowsPerPage}`;
      let link = UrlApi.team.get + query;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteTeam =
  ({ id, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.team.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${id}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageTeam =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      if (CheckDataIfExit(values?.name)) {
        bodyFormData.append("name", values?.name?.trim());
      }
      if (CheckDataIfExit(values?.position_title)) {
        bodyFormData.append("position_title", values?.position_title?.trim());
      }
      if (CheckDataIfExit(values?.position_description)) {
        bodyFormData.append(
          "position_description",
          values?.position_description?.trim()
        );
      }
      if (CheckDataIfExit(values?.bio)) {
        bodyFormData.append("bio", values?.bio?.trim());
      }
      if (CheckDataIfExit(values?.info)) {
        bodyFormData.append("info", values?.info?.trim());
      }
      if (CheckDataIfExit(values?.certificates)) {
        bodyFormData.append("certificates", values?.certificates?.trim());
      }
      if (CheckDataIfExit(values?.facebook_link)) {
        bodyFormData.append("facebook_link", values?.facebook_link?.trim());
      }
      if (CheckDataIfExit(values?.instagram_link)) {
        bodyFormData.append("instagram_link", values?.instagram_link?.trim());
      }
      if (CheckDataIfExit(values?.x_link)) {
        bodyFormData.append("x_link", values?.x_link?.trim());
      }
      if (CheckDataIfExit(values?.youtube_link)) {
        bodyFormData.append("youtube_link", values?.youtube_link?.trim());
      }
      if (CheckDataIfExit(values?.sort_order)) {
        bodyFormData.append("sort_order", values?.sort_order);
      }
      if (CheckDataIfExit(values?.email)) {
        bodyFormData.append("email", values?.email?.trim());
      }
      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        CheckImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode ? `${UrlApi.team.edit}/${paramID}` : UrlApi.team.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditTeam =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.team.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
